import React from 'react';
import TextField from 'material-ui/TextField';

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.onChangeInput = this.onChangeInput.bind(this);
    }

    onChangeInput() {
        this.props.changeSearch(this.refs.searchInput.input.value);
    }

    render() {
        return (
            <div className='paper-block margin-10'>
                <span className='name-block absolute small-name'>Search areas</span>

                <TextField
                    ref='searchInput'
                    floatingLabelText='Find area'
                    defaultValue=''
                    onChange={this.onChangeInput}
                    fullWidth
                />
            </div>
        );
    }
}

export default Search;



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/FilterAreas/Search.jsx